import { Col, Form, Row } from 'react-bootstrap';
import { DateFilterType } from '../types';
import { useTranslation } from "react-i18next";
import { FilterDto } from '../../../types/FilterDto';
import { useState, useEffect } from 'react';
import { InputDatePicker } from '../../InputDatePicker';


interface DateFilterProps {
  filter: FilterDto;
  values: DateFilterType;
  onSelectChange: (name: string, description:string, dateValues: DateFilterType) => void;
}

export default function DateFilter({ filter, values, onSelectChange }: DateFilterProps) {
    const { t } = useTranslation(['dashboard']);

    const handleInitialDateChange = (date: Date | null) => {
        if (!date) {
            onSelectChange(filter.name, filter.description, {
                initialDate: undefined,
                finalDate: values.finalDate,
            });
            return;
        }

        const normalized = new Date(date);
        normalized.setHours(0, 0, 0, 0);


        onSelectChange(filter.name, filter.description, {
            initialDate: normalized.getTime(),
            finalDate: values.finalDate,
        });
    };


    const handleFinalDateChange = (date: Date | null) => {
        if (date !== null) {
            date.setHours(23, 59, 59, 999);

            onSelectChange(filter.name, filter.description, {
                initialDate: values.initialDate,
                finalDate: date.getTime()
            });
        } else {
            onSelectChange(filter.name, filter.description, {
                initialDate: values.initialDate,
                finalDate: undefined,
            });
        }
    };

    // Sincronizar con valores externos
    const [initialDate, setInitialDate] = useState(
        values.initialDate ? new Date(values.initialDate) : null);
    const [finalDate, setFinalDate] = useState(
        values.finalDate ? new Date(values.finalDate) : null);

    useEffect(() => {
        setInitialDate(values.initialDate ? new Date(values.initialDate) : null);
    }, [values.initialDate]);

    useEffect(() => {
        setFinalDate(values.finalDate ? new Date(values.finalDate) : null);
    }, [values.finalDate]);

    return (
        <Form.Group controlId={`form${filter.name}DateSelect`}>
          <Row className="gx-3">
              <Col >
                  <InputDatePicker
                    value={initialDate}
                    onChange={handleInitialDateChange}
                    label={`${filter.description} ${t("dashboard:filters.Inicial")}`}
                    />
              </Col>

              <Col >
                  <InputDatePicker
                    value={finalDate}
                    onChange={handleFinalDateChange}
                    label={`${filter.description} ${t("dashboard:filters.Final")}`}
                    />
              </Col>
          </Row>
    </Form.Group>
  );
}